export const VIEW_CLONE_DIALOG = 'view-clone-dialog';
export const VIEW_CAMPAIGN = 'view-campaign';
export const VIEW_ASSIGN_PERMISSIONS = 'view-assign-permissions';
export const OPEN_CONVERT_FOLLECTED_FORM_DIALOG = 'open-convert-collected-form-dialog';
export const CREATE_CONTACTS_LIST = 'create-contacts-list';
export const DELETE_FORM = 'delete-form';
export const VIEW_DELETE_FORM = 'view-delete-form';
export const EDIT_FORM = 'edit-form';
export const EDIT_EMAIL_NOTIFICATIONS = 'edit-email-notifications';
export const VIEW_EDIT_MAILCHIMP_LISTS = 'view-edit-mailchimp-lists';
export const VIEW_EXPORT_FORM_SUBMISSIONS = 'view-export-form-submissions';
export const VIEW_MOVE_TO_FOLDER = 'view-move-to-folder';
export const VIEW_RENAME = 'view-rename';
export const TEST_FORM = 'test-form';
export const VIEW_TRANSLATE_FORM = 'view-translate-form';
export const UNPUBLISH_FORM = 'unpublish-form';
export const VIEW_FILE_UPLOADS = 'view-file-uploads';
export const VIEW_COLLECTED_FORM_DETAILS = 'view-collected-form-details';
export const VIEW_SIDE_PANEL = 'view-side-panel';
export const VIEW_PERFORMANCE = 'view-performance';
export const VIEW_SUBMISSIONS = 'view-submissions';
export const ANALYZE_TOGGLE_CHECKBOX = 'analyze-toggle-checkbox';
export const ANALYZE_CHANGE_SEARCH_QUERY = 'analyze-change-search-query';